/**
 * Converts a mask pattern to a regular expression for validation.
 *
 * Mask characters:
 * - 'a' represents any letter (a-z, A-Z)
 * - '0' represents any digit (0-9)
 * - All other characters are treated as literal characters
 */
export function maskToRegex(mask: string): RegExp {
    const escapedMask = mask.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regexPattern = escapedMask.replace(/a/g, "[a-zA-Z]").replace(/0/g, "\\d");
    return new RegExp(`^${regexPattern}$`);
}
